module.exports = __webpack_public_path__ + "media/images/common/ico-bell-on-07aa4f7b0c3612e8ee703bb07ba26ffa.svg";